<template>
  <div class="r-ipt-select common-flex common-justify-between" :style="{width:width+'px'}">
    <div class="title">{{config.label}}<span v-if="config.must" style="color: red">*</span></div>
    <div class="common-flex">
      <input type="text" :style="{width:iptWidth+'px'}"  v-model="config.inputValue" style="margin:0 5px">
      <Select v-model="config.value" :not-found-text="$t('noDate')" style="width: 80px" @on-change="changeIptSelect" placeholder=" ">
        <Option v-for="item in config.list" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
    </div>
  </div>
</template>

<script>
export default {
  name: "r-ipt-select",
  data() {
    return {
      
    };
  },
   /*label 标题
    must 是否必填,
    type 类型,
    inputvalue  输入数据
    value 选中数据
  */
    props:{
      config:Object,
      index:Number,
      width:{
        type:[Number,String],
        default:350
      },
      iptWidth:{
        type:Number,
        default:90
      },
  },
  methods:{
    // 修改输入框的下拉框
    changeIptSelect(e){
      this.$emit('changeIptSelect',this.index)
      console.log(this.index)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-ipt-select {
  width: 350px;
padding-bottom: 2px;
    border-bottom: .5px solid #666666;
  .title {
    width: 300px;
    flex-basis: 50%;
  }
  input {
    // width: 90px;
    // text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-ipt-select.vue